var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHugeiconsDesert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    color: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 7v14m4-3v3m-9 0h12M4 13v.96c0 .845 0 1.268.201 1.616s.567.56 1.3.982L8 18m4-9v2.96c0 .845 0 1.268-.201 1.616s-.567.56-1.3.982L8 16"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsDesert);
export default __webpack_public_path__ + "static/media/hugeicons--desert.f1f0c8c877142d4b05eef1211747d04b.svg";
export { ForwardRef as ReactComponent };